/**
 * om-pincode.js
 * ---------------------------------------------------------------------------
 * All-India delivery pincode checker.
 *
 * What it replaces: the product page shipped with a hard-coded WHITELIST of 98
 * pincodes in data-serviceable. Anything not on that list was told "we don't\n * deliver to this pincode yet" - which included Bikaner's own 334001. Keeping
 * that list current by hand is not workable for a pan-India store.
 *
 * New rule: any structurally valid Indian pincode is serviceable UNLESS it is
 * on the exclusion list. The list is a shop metafield (custom.excluded_pincodes)
 * so it can be edited in Shopify admin at any time, with no code change and no
 * theme publish. See snippets/pincode-rules.liquid for how it reaches the page.
 *
 * A valid Indian pincode is 6 digits and never starts with 0 or 9.
 * Exclusions may be full 6-digit codes, or a 2-3 digit prefix to block a whole
 * region (194 blocks every 194xxx).
 *
 * IMPORTANT - how the old handler is disabled:
 * The theme's own checker is DELEGATED from document, so replacing or cloning
 * the button does not detach it. We intercept on document in the CAPTURE phase,
 * which runs before any bubble-phase delegate, and call stopImmediatePropagation
 * so the original never sees the event.
 *
 * IMPORTANT - comment handling:
 * Exclusions are parsed LINE BY LINE and any line starting with # is dropped
 * whole. Parsing the blob as one stream of tokens looks equivalent but is not:
 * a number mentioned inside a help comment ("e.g. 194 blocks 194xxx") gets
 * read as a live exclusion and silently blocks a real region.
 */
(function () {
  'use strict';

  if (window.__omPincodeBound) return;
  window.__omPincodeBound = true;

  var STORE_KEY = 'om-pincode';

  function config() { return window.OM_PINCODE_CONFIG || {}; }

  function exclusions() {
    var raw = String(config().excluded || '');
    var out = [];

    var lines = raw.split(/[\r\n]+/);
    for (var i = 0; i < lines.length; i++) {
      var line = lines[i].trim();
      if (!line || line.charAt(0) === '#' || line.charAt(0) === '/') continue;

      var parts = line.split(/[\s,;]+/);
      for (var j = 0; j < parts.length; j++) {
        var p = parts[j].trim();
        if (p.charAt(0) === '#') break;      // trailing comment on a live line
        if (/^\d{2,6}$/.test(p)) out.push(p);
      }
    }
    return out;
  }

  function isValid(pin) { return /^[1-8]\d{5}$/.test(pin); }

  function isExcluded(pin) {
    var list = exclusions();
    for (var i = 0; i < list.length; i++) {
      var e = list[i];
      if (e.length === 6 ? pin === e : pin.indexOf(e) === 0) return true;
    }
    return false;
  }

  function check(pin) {
    var c = config();
    if (!pin) return { state: 'error', text: c.emptyText || 'Please enter your pincode.' };
    if (!isValid(pin)) return { state: 'error', text: c.invalidText || 'Please enter a valid 6-digit pincode.' };
    if (isExcluded(pin)) return { state: 'error', text: c.excludedText || 'Sorry, we are not delivering to this pincode right now.' };
    return { state: 'success', text: (c.successText || 'Great news! We deliver to {{pincode}}.').replace('{{pincode}}', pin) };
  }

  function paint(msgEl, result) {
    if (!msgEl) return;
    msgEl.textContent = result.text;
    msgEl.classList.remove('is-success', 'is-error');
    msgEl.classList.add(result.state === 'success' ? 'is-success' : 'is-error');
  }

  function runFor(box) {
    if (!box) return;
    var input = box.querySelector('.pdp__pincode-input');
    var msg = box.querySelector('.pdp__pincode-msg');
    if (!input) return;

    var pin = (input.value || '').replace(/\D/g, '').slice(0, 6);
    input.value = pin;

    var result = check(pin);
    paint(msg, result);

    if (result.state === 'success') {
      try { window.localStorage.setItem(STORE_KEY, pin); } catch (e) {}
    }

    setTimeout(function () { paint(msg, result); }, 60);
  }

  // ---- capture-phase interception: the original handler never fires ----

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.pdp__pincode-check');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    runFor(btn.closest('[data-pdp-pincode]') || btn.closest('.pdp__pincode'));
  }, true);

  document.addEventListener('keydown', function (e) {
    var input = e.target.closest && e.target.closest('.pdp__pincode-input');
    if (!input || e.key !== 'Enter') return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    runFor(input.closest('[data-pdp-pincode]') || input.closest('.pdp__pincode'));
  }, true);

  document.addEventListener('input', function (e) {
    var input = e.target.closest && e.target.closest('.pdp__pincode-input');
    if (!input) return;
    var cleaned = (input.value || '').replace(/\D/g, '').slice(0, 6);
    if (cleaned !== input.value) input.value = cleaned;
    var box = input.closest('[data-pdp-pincode]') || input.closest('.pdp__pincode');
    var msg = box && box.querySelector('.pdp__pincode-msg');
    if (msg && msg.textContent) {
      msg.textContent = '';
      msg.classList.remove('is-success', 'is-error');
    }
  }, true);

  // ---- setup ----

  function prepare(box) {
    if (box.getAttribute('data-om-pincode') === '1') return;
    box.setAttribute('data-om-pincode', '1');

    box.removeAttribute('data-serviceable');

    var input = box.querySelector('.pdp__pincode-input');
    if (input) {
      input.setAttribute('inputmode', 'numeric');
      input.setAttribute('maxlength', '6');
      input.setAttribute('autocomplete', 'postal-code');
      if (!input.value) {
        try {
          var saved = window.localStorage.getItem(STORE_KEY);
          if (saved && isValid(saved)) {
            input.value = saved;
            paint(box.querySelector('.pdp__pincode-msg'), check(saved));
          }
        } catch (e) {}
      }
    }
  }

  function scan() {
    var boxes = document.querySelectorAll('[data-pdp-pincode], .pdp__pincode');
    for (var i = 0; i < boxes.length; i++) prepare(boxes[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();

  var t = null;
  new MutationObserver(function () {
    clearTimeout(t);
    t = setTimeout(scan, 150);
  }).observe(document.documentElement, { childList: true, subtree: true });

  window.OMPincode = {
    check: check,
    isValid: isValid,
    isExcluded: isExcluded,
    exclusions: exclusions
  };
})();